import React from 'react'
import useEnterpriseContainer from './Styles'
import { EnterpriseAppBar } from 'components'
import { IEnterpriseContainerProps } from './Interfaces'
import cx from 'classnames'

const EnterpriseContainer: React.FC<IEnterpriseContainerProps> = ({ children, hasBottomBar, enterpriseLogo }) => {
  const classes = useEnterpriseContainer({})
  return (
    <div className={classes.root}>
      <EnterpriseAppBar enterpriseLogo={enterpriseLogo} />
      <div className={hasBottomBar ? cx(classes.content, classes.withBottomBar) : classes.content}>{children}</div>
    </div>
  )
}

export default EnterpriseContainer
